/* tslint:disable */
/* eslint-disable */
/**
 * Organization & Workspace Gateway
 * Methods to manage all organizations and workspaces
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    IncentivePlanMerchantEligibility,
    IncentivePlanMerchantEligibilityFromJSON,
    IncentivePlanMerchantEligibilityFromJSONTyped,
    IncentivePlanMerchantEligibilityToJSON,
    IncentivePlanUserTargeting,
    IncentivePlanUserTargetingFromJSON,
    IncentivePlanUserTargetingFromJSONTyped,
    IncentivePlanUserTargetingToJSON,
    IncentiveTemplate,
    IncentiveTemplateFromJSON,
    IncentiveTemplateFromJSONTyped,
    IncentiveTemplateToJSON,
    Schedule,
    ScheduleFromJSON,
    ScheduleFromJSONTyped,
    ScheduleToJSON,
} from './';

/**
 * 
 * @export
 * @interface IncentivePlanConfiguration
 */
export interface IncentivePlanConfiguration {
    /**
     * Title of the incentive plan
     * @type {string}
     * @memberof IncentivePlanConfiguration
     */
    name?: string;
    /**
     * Description of the incentive plan
     * @type {string}
     * @memberof IncentivePlanConfiguration
     */
    description?: string;
    /**
     * 
     * @type {IncentiveTemplate}
     * @memberof IncentivePlanConfiguration
     */
    incentiveTemplate?: IncentiveTemplate;
    /**
     * 
     * @type {Schedule}
     * @memberof IncentivePlanConfiguration
     */
    schedule?: Schedule;
    /**
     * 
     * @type {IncentivePlanMerchantEligibility}
     * @memberof IncentivePlanConfiguration
     */
    merchantEligibility?: IncentivePlanMerchantEligibility;
    /**
     * 
     * @type {IncentivePlanUserTargeting}
     * @memberof IncentivePlanConfiguration
     */
    userTargeting?: IncentivePlanUserTargeting;
}

export function IncentivePlanConfigurationFromJSON(json: any): IncentivePlanConfiguration {
    return IncentivePlanConfigurationFromJSONTyped(json, false);
}

export function IncentivePlanConfigurationFromJSONTyped(json: any, ignoreDiscriminator: boolean): IncentivePlanConfiguration {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'incentiveTemplate': !exists(json, 'incentiveTemplate') ? undefined : IncentiveTemplateFromJSON(json['incentiveTemplate']),
        'schedule': !exists(json, 'schedule') ? undefined : ScheduleFromJSON(json['schedule']),
        'merchantEligibility': !exists(json, 'merchantEligibility') ? undefined : IncentivePlanMerchantEligibilityFromJSON(json['merchantEligibility']),
        'userTargeting': !exists(json, 'userTargeting') ? undefined : IncentivePlanUserTargetingFromJSON(json['userTargeting']),
    };
}

export function IncentivePlanConfigurationToJSON(value?: IncentivePlanConfiguration | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'description': value.description,
        'incentiveTemplate': IncentiveTemplateToJSON(value.incentiveTemplate),
        'schedule': ScheduleToJSON(value.schedule),
        'merchantEligibility': IncentivePlanMerchantEligibilityToJSON(value.merchantEligibility),
        'userTargeting': IncentivePlanUserTargetingToJSON(value.userTargeting),
    };
}


